import styled from 'styled-components';

export const Overlay = styled.div`
  height: 100%;
  width: 100%;
  opacity: 0.8;
  background: linear-gradient(135deg, #D60000 0%, #5900C3 100%);
  position: absolute;
  z-index: 2;
`;

export const Gif = styled.div`
  margin: 0px;
  background-size: cover;
  background-image: url('https://media.giphy.com/media/hEc4k5pN17GZq/giphy.gif');
  width: 100%;
  height: 100%;
  position: absolute;
  z-index1;
`;

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;

  .logo {
    margin-top: 27px;
    margin-left: 40px;
    position: relative;
    z-index: 2;
  }

  h1,p,a {
    margin: 0px;
    color: white;
    margin: 0px auto;
    position: relative;
    z-index: 3;
    font-family: "myriad-pro",sans-serif;
    font-style: normal;
    font-weight: 700;

  }

  h1 {
    margin-top: 244px;
    font-size: 36px;
    font-weight: bold;
    line-height: 44px;
    width: 460px;
  }

  p {
    margin-top: 20px;
    font-size: 14px;
    line-height: 20px;
    width: 460px;
    font-weight: 400;
  }

  a {
    margin-top: 108px;
    display: table;
    padding: 10px 25px;
    text-decoration: none;
    font-size: 12px;
    font-weight: bold;
    line-height: 17px;
    text-align: center;
    border-radius: 3px;
    background-color: #007AFF;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/FourOhFourPage/styledComponents.js